import { Buffer } from "buffer";
export async function blobToBase64(blob: Blob): Promise<string> {
  const arrayBuffer = await blob.arrayBuffer();

  const buffer = Buffer.from(arrayBuffer);
  const base64String = buffer.toString("base64");

  return base64String;
}
